import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"

export const useGenerateCertificate = () => {
  return useGenereicMutation<{ roundId: number }>({
    createEndpoint: (data) => ENDPOINTS.certificates.generate(data.roundId),
    method: HTTP_METHODS.POST,
    invalidationKeys: [QUERY_KEYS.certificates.index()],
  })
}
